<div class="tile-padding-first tile-padding">
  <h3>{{header}}</h3>

  <app-data-table
    [columns]="columns"
    [data]="rows"
    [serverSide]="displayall"
    [totalCount]="totalCount"
    [pageSize]="pageSize"
    [loading]="loading"
    tableId="missing-submissions"
    (pageChange)="onPageChange($event)"
    emptyMessage="No Missing Submissions Found"
    (rowClick)="onDataclicked($event)">

    <ng-template appColumnCell="student" let-element>
      <span class="tw:w-full tw:items-center tw:flex">
        <div class="student-group-icon-container tw:mr-2 tw:float-left"
          [ngClass]="{'single-student-icon': !element.isGroupPlacement,
                        'group-one-student-icon': element.isGroupPlacement && element.groupSize == 1,
                        'group-two-student-icon': element.isGroupPlacement && element.groupSize == 2,
                        'group-three-student-icon': element.isGroupPlacement && element.groupSize == 3,
                        'group-multiple-student-icon': element.isGroupPlacement && element.groupSize > 3}"></div>{{element.isGroupPlacement == true ? element.groupName : element.student}}
      </span>
    </ng-template>

    <ng-template appColumnCell="brand" let-element>
      {{element.companyId | brandShortCode: brands}}
    </ng-template>

    <ng-template appColumnCell="time" let-element>
      {{element.sessionStartDate | date : 'HH:mm'}} - {{element.sessionEndDate | date : 'HH:mm'}}
    </ng-template>

    <ng-template appColumnCell="timeSheet" let-element>
      <i class="{{element.isTimesheetSaved === true ? 'las la-check' : 'las la-times'}}"></i>
    </ng-template>

    <ng-template appColumnCell="session" let-element>
      <i class="{{element.isSessionSubmitted === true ? 'las la-check' : 'las la-times'}}"></i>
    </ng-template>

    <ng-template appColumnCell="outcome" let-element>
      <i class="{{element.isOutcomeSubmitted === true ? 'las la-check' : 'las la-times'}}"></i>
    </ng-template>
  </app-data-table>
</div>
